__turbopack_context__.v({
  "down": "Compare-module-scss-module__4rhwTq__down",
  "flat": "Compare-module-scss-module__4rhwTq__flat",
  "icon": "Compare-module-scss-module__4rhwTq__icon",
  "text": "Compare-module-scss-module__4rhwTq__text",
  "up": "Compare-module-scss-module__4rhwTq__up",
  "wrapper": "Compare-module-scss-module__4rhwTq__wrapper",
});
